function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B4BFE9D4-9F78-47AE-80C5-95CC1DB6F0A7");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pers\\xF6nliche-Angaben-03-Geschlecht",
  transform: "translate(-586.000000, -464.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Frage",
  transform: "translate(568.000000, 384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card-Antwort-1-HOVER",
  transform: "translate(0.000000, 62.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,9.02269345 C17,11.7963914 14.7615185,14.0450149 12,14.0450149 C9.23848148,14.0450149 7,11.7965402 7,9.02269345 C7,6.24828869 9.23848148,4 12,4 C14.7615185,4 17,6.2484747 17,9.02269345 M12,14.4122024 L12,20 M9.59085185,17.5226935 L14.4167778,17.5226935",
  id: "Combined-Shape",
  stroke: "#FFFFFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))));

var SvgWeiblich = function SvgWeiblich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeiblich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weiblich.a0b1aa99.svg";
export { ForwardRef as ReactComponent };